import React from "react";

export default function Preloader() {
  return (
    <div className="preloader" aria-hidden="true">
      <div className="preloader__box">
        <svg
          className="preloader__svg"
          width="80"
          height="791"
          viewBox="0 0 80 791"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="79"
            height="790"
            rx="4.5"
            stroke="#9747FF"
            strokeDasharray="10 5"
          />
          <path
            d="M35.6435 127.652C38.5235 127.652 39.8195 126.356 39.8195 123.44H42.8795V149H38.9915V130.784H33.5915V127.652H35.6435Z"
            fill="white"
          />
          <path
            d="M30.6821 191.252C31.2581 186.428 34.7861 182.864 40.0781 182.864C44.9741 182.864 48.5741 186.032 48.5741 190.316C48.5741 194.096 45.5501 196.508 41.8061 198.812C39.9701 199.82 35.2181 203.06 35.0741 205.436H48.7181V209H30.2861C30.2861 201.404 35.3621 198.416 40.0061 195.608C42.6701 193.916 44.5421 192.152 44.5421 190.28C44.5421 188.012 42.7061 186.428 40.0781 186.428C37.2341 186.428 35.3261 188.228 34.7141 191.504L30.6821 191.252Z"
            fill="white"
          />
          <path
            d="M39.2844 253.808C41.5164 253.844 44.1084 252.764 44.1084 249.776C44.1084 247.724 42.2724 246.428 39.2844 246.428C36.8004 246.428 35.1084 247.616 34.8204 249.524L30.7884 249.272C31.2924 245.492 34.7484 242.864 39.3204 242.864C44.6124 242.864 48.1764 245.564 48.1764 249.524C48.1764 252.404 46.4844 254.312 43.2084 255.176C46.9524 256.148 49.0404 258.596 49.0404 261.98C49.0404 266.516 45.1164 269.576 39.3204 269.576C33.9924 269.576 30.2124 266.552 29.9964 262.124L33.9924 261.908C34.2444 264.824 36.9444 266.012 39.3204 266.012C42.1284 266.012 44.9724 264.716 44.9724 261.512C44.9724 258.38 42.0924 256.976 39.2844 257.048L37.2324 257.084V253.772L39.2844 253.808Z"
            fill="white"
          />
          <path
            d="M46.085 303.44V320.396H48.929V323.96H46.085V329H42.197V323.96H29.057V320.396L41.693 303.44H46.085ZM33.593 320.396H42.197V308.912L33.593 320.396Z"
            fill="white"
          />
          <path
            d="M46.6568 363.44V367.004H35.3168L34.3088 374.348C35.4968 372.836 37.8368 371.972 40.1048 371.972C44.9648 371.972 48.4208 375.608 48.4208 380.648C48.4208 385.904 44.6048 389.576 39.2048 389.576C33.9128 389.576 29.9528 386.588 29.5928 382.268L33.5888 382.016C33.9848 384.536 36.3608 386.012 39.1328 386.012C42.2648 386.012 44.3888 383.816 44.3888 380.684C44.3888 377.372 42.2288 375.284 38.8808 375.284C36.6488 375.284 34.7768 376.328 34.0208 377.984H29.9528L31.9328 363.44H46.6568Z"
            fill="white"
          />
          <path
            d="M44.8686 429.38C44.1486 427.472 42.4926 426.392 40.2606 426.392C36.5166 426.392 34.3206 429.668 33.9246 435.428C35.2926 433.052 37.5966 431.756 40.3326 431.756C45.4086 431.756 48.8286 435.356 48.8286 440.54C48.8286 446.156 44.9406 449.576 39.5046 449.576C37.0926 449.576 34.7526 448.676 32.8446 446.66C31.0446 444.752 30.1806 441.548 30.1806 437.66C30.1806 429.92 32.8446 422.864 40.2966 422.864C44.2926 422.864 47.6046 425.096 48.7206 429.128L44.8686 429.38ZM34.2486 440.54C34.1766 443.816 36.4086 446.156 39.6126 446.156C42.7086 446.156 44.8326 443.816 44.8326 440.54C44.8326 437.372 42.7806 435.104 39.8286 435.104C36.5886 435.104 34.2846 437.372 34.2486 440.54Z"
            fill="white"
          />
          <path
            d="M29.822 483.44H48.182V486.752C43.214 492.944 39.83 500.54 39.902 509H35.906C35.906 500.9 39.11 493.268 44.15 487.004H29.822V483.44Z"
            fill="white"
          />
          <path
            d="M39.518 569.576C33.65 569.576 29.654 566.66 29.654 561.98C29.654 558.776 31.562 556.292 34.802 555.14C32.318 554.168 30.878 552.476 30.878 549.884C30.878 545.816 34.406 542.864 39.518 542.864C44.63 542.864 48.158 545.816 48.158 549.884C48.158 552.476 46.682 554.168 44.198 555.14C47.438 556.328 49.382 558.812 49.382 561.98C49.382 566.66 45.35 569.576 39.518 569.576ZM33.686 561.548C33.686 564.284 35.954 566.012 39.518 566.012C43.046 566.012 45.314 564.284 45.314 561.548C45.314 558.848 43.046 557.084 39.518 557.084C35.954 557.084 33.686 558.848 33.686 561.548ZM34.874 550.064C34.874 552.296 36.674 553.7 39.518 553.7C42.362 553.7 44.09 552.296 44.09 550.064C44.09 547.832 42.362 546.428 39.518 546.428C36.674 546.428 34.874 547.832 34.874 550.064Z"
            fill="white"
          />
          <path d="M29.2276 603.019H25V628.574H29.2276V603.019Z" fill="white" />
          <path
            d="M44.3381 615.906L42.1219 620.243L37.852 628.581H33.2998L39.9199 615.941L33.2998 603.019H37.598L42.1431 611.7L44.3381 615.906Z"
            fill="white"
          />
          <path
            d="M45.9546 615.925L48.1778 620.262L52.4477 628.6H56.9999L50.3798 615.959L56.9999 603.037H52.7018L48.1566 611.718L45.9546 615.925Z"
            fill="white"
          />
          <path d="M29.2276 663.019H25V688.574H29.2276V663.019Z" fill="#1D2939" />
          <path
            d="M44.3381 675.906L42.1219 680.243L37.852 688.581H33.2998L39.9199 675.941L33.2998 663.019H37.598L42.1431 671.7L44.3381 675.906Z"
            fill="#1D2939"
          />
          <path
            d="M45.9546 675.925L48.1778 680.262L52.4477 688.6H56.9999L50.3798 675.959L56.9999 663.037H52.7018L48.1566 671.718L45.9546 675.925Z"
            fill="#1D2939"
          />
          <path d="M29.2276 723.019H25V748.574H29.2276V723.019Z" fill="#191690" />
          <path
            d="M44.3381 735.906L42.1219 740.243L37.852 748.581H33.2998L39.9199 735.941L33.2998 723.019H37.598L42.1431 731.7L44.3381 735.906Z"
            fill="#191690"
          />
          <path
            d="M45.9546 735.925L48.1778 740.262L52.4477 748.6H56.9999L50.3798 735.959L56.9999 723.037H52.7018L48.1566 731.718L45.9546 735.925Z"
            fill="#191690"
          />
        </svg>
      </div>
    </div>
  );
}
